<template>
  <el-row class="index-main">
    <el-row class="yujing">
      <el-row>
        <span style="font-size: 20px; color: #888888">预警提醒</span>
      </el-row>
      <el-row style="margin-top: 35px">
        <ul class="my-ul">
          <!-- 收到的竞价单-竞价-待报价 -->
          <li
            class="center hand"
            @click="
              toUrl(
                '/goods/get-rush-bidding-list?status=AwaitOffer',
                'QIANGDANJINGJIABIAO_WOSHOUDAODE'
              )
            "
          >
            <el-row class="round red">{{ quote_bidding }}</el-row>
            <el-row class="mt-15">待报价（单）</el-row>
          </li>
          <!-- 收到的委托单-待处理 -->
          <li
            class="center hand"
            @click="
              toUrl(
                '/goods/entrust-carrier-list?status=TO_FEEDBACK',
                'WOYAODIAODU_SHOUDAOWEITUODAN'
              )
            "
          >
            <el-row class="round yellow">{{ send_sum }}</el-row>
            <el-row class="mt-15">待派车（单）</el-row>
          </li>
          <!-- 运单列表：支付完成，定位失败，回单已传 -->
          <li
            class="center hand"
            @click="
              toUrl(
                '/waybill/waybill-list?pay_status=PaymentEnd&position_status=PositionFailure&receipt_status=UN_LOAD',
                'YUNDANGENZONG_YUNDANLIEBIAO'
              )
            "
          >
            <el-row class="round perpur">{{ location_anomaly }}</el-row>
            <el-row class="mt-15">追踪异常（单）</el-row>
          </li>
          <!-- 财务管理-申请运费-支付失败页签页面。 -->
          <li
            class="center hand"
            @click="
              toUrl(
                '/settle/waybill-apply-list?active=active',
                'CAIWUGUANLI_SHENQINGYUNFEI'
              )
            "
          >
            <el-row class="round blue">{{ failing_waybill }}</el-row>
            <el-row class="mt-15">支付失败（单）</el-row>
          </li>
          <!-- 车辆存在，跳转到车辆管理审核不通过，不存在，跳转到船舶管理审核不通过 -->
          <li class="center hand" @click="toError">
            <el-row class="round green">{{ vehicle_not_sum }}</el-row>
            <el-row class="mt-15">认证失败（辆）</el-row>
          </li>
          <!-- 财务管理-申请运费-筛选条件为审核不通过的运单界面 -->
          <li
            class="center hand"
            @click="
              toUrl(
                '/settle/waybill-apply-list?pay_audit_status=NotAuditPass',
                'CAIWUGUANLI_SHENQINGYUNFEI'
              )
            "
          >
            <el-row class="round blue">{{ audit_failing }}</el-row>
            <el-row class="mt-15">审核失败（单）</el-row>
          </li>
        </ul>
      </el-row>
    </el-row>
    <el-row class="box main-bd">
      <el-row class="list-title clearfix">
        <ul class="list-nav fl clearfix">
          <li :class="active" @click="zhipai">指 派（{{ data.entrust }}）</li>
          <li :class="active1" @click="qiangdan">
            抢单竞价生成（{{ data.bid_or_rob }}）
          </li>
        </ul>
      </el-row>
      <span
        class="mainColor hand"
        style="position: absolute; top: 40px; right: 30px"
        @click="toUrl('/goods/entrust-carrier-list')"
      >
        更多委托单 >
      </span>
      <el-row style="margin-bottom: 5px">
        <span class="grayColor">
          委托总量：
          <!-- <em class="mainColor">{{data.goods_total}}</em> 吨 -->
          <em
            class="mainColor mr-5"
            v-for="(item, index) in data.goods_total_list"
            :key="index"
            >{{ item.weight_count }} {{ item.metering_unit }},</em
          >
        </span>
        <span class="grayColor" style="margin-left: 20px">
          承运总量：
          <!-- <em class="mainColor">{{data.carrying_amount}}</em> 吨 -->
          <em
            class="mainColor mr-5"
            v-for="(item, index) in data.carrying_amount_list"
            :key="index"
            >{{ item.weight_count }} {{ item.metering_unit }},</em
          >
        </span>
        <span class="grayColor" style="margin-left: 20px">
          库存总量：
          <!-- <em class="mainColor">{{data.inventory_amount}}</em> 吨 -->
          <em
            class="mainColor mr-5"
            v-for="(item, index) in data.inventory_amount_list"
            :key="index"
            >{{ item.weight_count }} {{ item.metering_unit }},</em
          >
        </span>
      </el-row>
      <el-table
        class="nth"
        :empty-text="empty_text"
        border
        ref="multipleTable"
        :data="data.content"
        style="width: 100%"
      >
        <el-table-column min-width="130" label="委托单号">
          <template slot-scope="scope">
            <el-row>
              <el-col :span="20">
                <p v-if="scope.row.number" style="font-size: 12px">
                  自编号：{{ scope.row.number }}
                </p>
                <p v-if="showCode">{{ scope.row.code }}</p>
                <span
                  @click="
                    toUrl(
                      '/goods/entrust-carrier-details?pid=' +
                        scope.row.pid +
                        '&num=' +
                        scope.row.num,
                      'WOYAODIAODU_SHOUDAOWEITUODAN_WEITUODANXIANGQING'
                    )
                  "
                  type="text"
                  class="link mainColor"
                  >{{ scope.row.entrust_code }}</span
                >
                <p v-if="scope.row.commission_id !== null">
                  欧冶委托单号：{{ scope.row.commission_id }}
                </p>
              </el-col>
              <el-col :span="4">
                <i
                  class="mark"
                  style="background: blue; float: right"
                  v-if="
                    scope.row.entrust_state == 'EntirelyWaybill' ||
                    scope.row.entrust_state == 'PortionWaybill'
                  "
                  >派</i
                >
                <i
                  class="mark"
                  style="background: #67c23a"
                  v-if="scope.row.entrust_state == 'Bidding'"
                  >竞</i
                >
                <i
                  class="mark"
                  style="background: green"
                  v-if="scope.row.entrust_state == 'Entrust'"
                  >分</i
                >
                <!-- <i class="mark" style="background:#cc0816" v-if="scope.row.entrust_state=='IntermodalTransport'">联</i> -->
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column prop="entrusting_per" label="委托方"></el-table-column>
        <el-table-column min-width="150" label="线路">
          <template slot-scope="scope">
            <ul>
              <li>
                <i class="iconfont icon-icon48 mainColor"></i>
                {{ scope.row.loading_address_province }}/{{
                  scope.row.loading_address_city
                }}/{{ scope.row.loading_address_area }}
              </li>
              <li>
                <i class="iconfont icon-icon48 green"></i>
                {{ scope.row.unloading_address_province }}/{{
                  scope.row.unloading_address_city
                }}/{{ scope.row.unloading_address_area }}
              </li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column prop="goods_total" label="委托量"></el-table-column>
        <el-table-column
          prop="carrying_amount"
          label="承运量"
        ></el-table-column>
        <el-table-column
          prop="inventory_amount"
          label="库存量"
        ></el-table-column>
        <el-table-column
          prop="valuation_type_text"
          label="计价方式"
          min-width="65"
        ></el-table-column>
        <el-table-column
          prop="create_time"
          label="创建日期"
          min-width="120"
        ></el-table-column>
        <el-table-column align="center" label="操作" min-width="130">
          <template slot-scope="scope">
            <el-row>
              <!-- :disabled="scope.row.entrustButton" -->
              <el-button
                v-if="scope.row.appoint"
                @click="toUrl('/goods/bidding-send?pid=' + scope.row.pid)"
                type="text"
                >生成竞价单</el-button
              >
              <el-button
                v-if="scope.row.sendCar"
                type="text"
                @click="toUrl('/car/car-send?pid=' + scope.row.pid)"
                >派车</el-button
              >
              <!-- <el-button v-if="scope.row.IntermodalTransport" type="text" @click="transport(scope.row.pid)" disabled>联运</el-button> -->
              <!-- 节点更新 -->
              <el-button
                v-if="scope.row.commission_id && scope.row.dispatch_id"
                type="text"
                @click="
                  transfer(scope.row.commission_id, scope.row.dispatch_id)
                "
                >转单</el-button
              >
            </el-row>
            <el-row>
              <el-button
                v-if="scope.row.appoint"
                @click="
                  toUrl(
                    '/goods/entrust-send?pid=' +
                      scope.row.pid +
                      '&num=' +
                      scope.row.num
                  )
                "
                type="text"
                >指定承运方</el-button
              >
              <el-button
                v-if="scope.row.cancel"
                type="text"
                @click="cancel(scope.row.pid)"
                >取消</el-button
              >
              <el-button
                v-if="scope.row.see"
                type="text"
                @click="see(scope.row.pid)"
                >查看</el-button
              >
              <span v-if="scope.row.cancelTransport">已取消运输</span>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </el-row>
</template>
<script>
import { isSuccess } from "@/assets/js/utils";
export default {
  data() {
    return {
      data: {
        content: [],
      },
      active: "active",
      active1: "",
      showCode: false, //竞价单号是否显示
      empty_text: "数据更新中，请稍后",
      search: {
        value2: "",
        entrusting_per: "",
        entrust_shipper_state: "all",
        entrust_code: "",
        create_time_begin: "",
        create_time_finish: "",
        type: 1,
        paging: {
          page_size: 10,
          total: 0,
          pages: 0,
          page_num: 1,
        },
      },
      quote_bidding: null,
      send_sum: null,
      location_anomaly: null,
      failing_waybill: null,
      vehicle_not_sum: null,
      audit_failing: null,
      num: "",
    };
  },
  mounted() {
    this.loadList();
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val.path == "/") {
          this.loadList();
        }
      },
      deep: true,
    },
  },
  methods: {
    //节点更新
    transfer(commission_id, dispatch_id) {
      if (confirm("确认更新转单节点？")) {
        this.rr.commission_id = commission_id;
        this.rr.dispatch_id = dispatch_id;
        //弹窗确定是否操作
        api("entrust.transfer", this.rr).then((res) => {
          alert(res.msg);
        });
      }
    },
    //取消
    cancel(pid) {
      if (confirm("确认取消？")) {
        api("entrust.receive.cancel.entrust.update", { id: pid }).then(
          (res) => {
            let data;
            if ((data = isSuccess(res))) {
            }
            alert(res.msg);
            this.loadList();
          }
        );
      }
    },
    see(pid) {
      //查看
      api("entrust.examine.query", { id: pid }).then((res) => {
        let data;
        if ((data = isSuccess(res))) {
          if (data.entrust_state == "Entrust") {
            toUrl("/goods/entrust-client-details?pid=" + data.id);
          } else if (data.entrust_state == "Bidding") {
            toUrl("/goods/bidding-client-details?pid=" + data.id);
          } else {
            toUrl("/goods/entrust-carrier-details?pid=" + pid);
          }
        }
      });
    },
    loadList() {
      api("indexsum.not.quote.bidding.sum").then((res) => {
        let data = isSuccess(res);
        this.quote_bidding = data;
      });
      api("indexsum.take.send.sum").then((res) => {
        let data = isSuccess(res);
        this.send_sum = Math.floor(data);
      });
      api("indexsum.waybill.location.anomaly").then((res) => {
        let data = isSuccess(res);
        this.location_anomaly = data;
      });
      api("indexsum.pay.failing.waybill").then((res) => {
        let data = isSuccess(res);
        this.failing_waybill = data;
      });
      api("indexsum.vehicle.not").then((res) => {
        let data = isSuccess(res);
        if (data.car_num == 0) {
          this.vehicle_not_sum = data.ship_num;
          this.num = 1;
        } else {
          this.num = 0;
          this.vehicle_not_sum = data.car_num;
        }
      });
      api("indexsum.audit.failing.waybill").then((res) => {
        let data = isSuccess(res);
        this.audit_failing = data;
      });
      this.search = getCache(this.search);
      api("entrust.receive.entrust.query", this.search, true).then((res) => {
        let data;
        if ((data = isSuccess(res))) {
          this.data = data;
          this.data.content = data.receive_entrust_list;
          if (this.data.content.length == 0) {
            this.empty_text = "暂无数据";
          }
          this.search.paging.total = res.data_total;
          if (this.search.type == 2) {
            this.showCode = true;
          } else {
            this.showCode = false;
          }
          //生成竞价单按钮显示条件
          this.data.content = this.data.content.map((item) => {
            item.num = 0;
            // if (item.entrust_state == "Created") {
            //   item.entrustButton = true;
            // } else {
            //   item.entrustButton = false;
            // }
            if (item.entrust_state == "Created" && item.bid_num == 1) {
              item.appoint = true;
            } else {
              item.appoint = false;
            }
            if (item.entrust_state == "Created") {
              //待反馈
              // item.appoint = true;
              item.sendCar = true;
              item.cancel = true;
              item.see = false;
              item.cancelTransport = false;
            } else if (item.entrust_state == "Refused") {
              //已拒单
              item.appoint = false;
              item.sendCar = false;
              item.cancel = false;
              item.see = false;
              item.cancelTransport = true;
            } else if (
              item.entrust_state == "EntirelyWaybill" ||
              item.entrust_state == "Bidding" ||
              item.entrust_state == "Entrust" ||
              item.entrust_state == "IntermodalTransport"
            ) {
              //已处理
              item.appoint = false;
              item.sendCar = false;
              item.cancel = false;
              item.see = true;
              item.cancelTransport = false;
            } else if (item.entrust_state == "Completed") {
              //已完成
              item.appoint = false;
              item.sendCar = false;
              item.cancel = false;
              item.see = true;
              item.cancelTransport = false;
            } else if (item.entrust_state == "PortionWaybill") {
              //部分派单
              item.appoint = false;
              item.sendCar = true;
              item.cancel = false;
              item.see = false;
              item.cancelTransport = false;
            }
            return item;
          });
        }
      });
    },
    zhipai() {
      this.search.type = 1;
      this.active = "active";
      this.active1 = "";
      this.loadList();
    },
    qiangdan() {
      this.search.type = 2;
      this.active = "";
      this.active1 = "active";
      this.loadList();
    },
    toError() {
      // this.num = 0跳转到车
      if (this.num == 0) {
        toUrl(
          "/vehicle/vehicle-car-list?audit_status=AuditNotPass",
          "YUNLIKU_CHELIANGGUANLI"
        );
      } else {
        toUrl(
          "/vehicle/vehicle-ship-list?audit_status=AuditNotPass",
          "YUNLIKU_CHUANBOGUANLI"
        );
      }
    },
  },
};
</script>
<style scoped lang="scss">
.my-sum {
  position: absolute;
  top: 41px;
  left: 30%;
}
.list-title {
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 20px;
}
.list-nav {
  border: 1px solid #e5e5e5;
  border-bottom: none;
  margin-right: 10px;
}
.list-nav li {
  float: left;
  width: 170px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  font-size: 14px;
  background: #f9f9f9;
  cursor: pointer;
}
.list-nav li.active {
  color: #fff;
  background: #cc0816;
}
.list-nav li:hover {
  color: #fff;
  background: #cc0816;
}
.yujing {
  height: 260px;
  background: #fff;
  margin-bottom: 30px;
  padding: 30px;
}
.center {
  text-align: center;
  float: left;
  // margin-right: 9%;
}
.my-ul .center:last-child {
  margin-right: 0;
}
.mr-5 {
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/index-carrier.vue